import React from 'react';
import { search, inputWrapper, input, label } from './ItemsSearch.module.css';
import Input from '../UI/Input';
import { func } from 'prop-types';
import classNames from 'classnames/bind';

const itemsSearchStyles = classNames.bind({ input })

const ItemsSearch = ({ onSearch }) => (
  <form className={search}>
    <Input
      id="filter"
      onChange={({ target: { value } }) => onSearch(value)}
      type="text"
      placeholder="start typing here..."
      styles={itemsSearchStyles}
      labelStyles={label}
      label="Looking for"
      inputWrapperStyles={inputWrapper}
    />
  </form>
)

ItemsSearch.propTypes = {
  onSearch: func,
}

ItemsSearch.defaultProps = {
  onSearch: () => { },
}

export default ItemsSearch